import React from 'react';
import * as Inovx from '@shared';
import UserActions from '../actions/UserActions';

var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader:any;

interface ChangeUserPasswordProps {
    User: IUser;
    onPasswordChanged: () => void;
    onCancel: () => void;
    message?: string;
}

interface ChangeUserPasswordState {
    validation: IValidationObject;
    newPassword: string;
    confirmPassword: string;
}

class ChangeUserPassword extends React.Component<ChangeUserPasswordProps, ChangeUserPasswordState> {
    private _user: any = {};
    constructor(props: ChangeUserPasswordProps, context: any) {
        super(props, context);

        this.state = {
            validation: { invalidInput: false, invalidValue: false, invalidInputMessage: "", invalidValueMessage: "" },
            newPassword: "",
            confirmPassword: ""
        };
    }

    private _changePassword = () => {

        let curState = this._cloneState(this.state);

        if (this._validatePasswordState(curState)) {
            this.setState(curState);

            var that = this;

            UserActions.changePassword(this.props.User, this.state.newPassword, this.props.onPasswordChanged,
                (error: IServiceErrorObject) => {
                    if (error.messageObj.propertyName) {
                        that.setState({
                            validation: {
                                invalidValue: true,
                                invalidValueMessage: error.messageObj.message,
                                invalidInput: false,
                                invalidInputMessage: ""
                            }
                        });
                    }
                });
        }
        else {
            this.setState(curState);
        }
    }

    private _validatePasswordState = (state: ChangeUserPasswordState) => {
        if (state.newPassword !== state.confirmPassword) {
            state.validation.invalidValueMessage = InovxLoader.t("users:form.passwordMustMatch");
            state.validation.invalidValue = true;

            return false;
        } else if (!state.newPassword) {
            state.validation.invalidValueMessage = Inovx.Shared.Common.CommonMessages.Validation.Required;
            state.validation.invalidValue = true;

            return false;
        } else {
            state.validation.invalidValue = false;

            return true;
        }
    }

    private _onPasswordChanged = (event: any) => {
        let newState = this._cloneState(this.state);
        newState.newPassword = event.target.value;

        this._validatePasswordState(newState);

        this.setState(newState);
    }

    private _onConfirmChanged = (event: any) => {
        let newState = this._cloneState(this.state);
        newState.confirmPassword = event.target.value;

        this._validatePasswordState(newState);

        this.setState(newState);
    }

    private _cloneState = (state: ChangeUserPasswordState): ChangeUserPasswordState => {
        return {
            newPassword: state.newPassword,
            confirmPassword: state.confirmPassword,
            validation: {
                invalidInput: state.validation.invalidInput,
                invalidValue: state.validation.invalidValue,
                invalidInputMessage: state.validation.invalidInputMessage,
                invalidValueMessage: state.validation.invalidValueMessage
            }
        }
    }

    render() {

        var passwordInput = {
            className: 'form-control',
            type: 'password',
            name: 'Password'
        };

        return (
            <div className="panel panel-primary user-change-password">
                <div className="panel-heading">{InovxLoader.t('users:form.changePasswordHeader')}</div>
                <div className="panel-body fc-margin">
                    {(this.props.message != null) && <p>{this.props.message}</p>}
                    <InovxControls.FormField title={`${InovxLoader.t("users:form.newPassword")}*`} inputName='Password'>
                        <InovxControls.ValidationInput {...passwordInput}  id= "new-pw-input" value={this.state.newPassword} onChange={this._onPasswordChanged} validation={this.state.validation} autocomplete="new-password" />
                    </InovxControls.FormField>

                    <InovxControls.FormField title={`${InovxLoader.t("users:form.confirmPassword")}*`} inputName='Password'>
                        <InovxControls.ValidationInput {...passwordInput} id= "confirm-pw-input" value={this.state.confirmPassword} onChange={this._onConfirmChanged} validation={this.state.validation} autocomplete="new-password" />
                    </InovxControls.FormField>

                    <div className="btn-bar-b-sm">
                        <button id= "change-pw-ok-btn" type="button" className="btn btn-primary" onClick={this._changePassword}>{InovxLoader.t('users:form.changePassword') }</button>
                        <button id= "change-pw-cancel-btn" type="button" className="btn btn-default" onClick={this.props.onCancel}>{InovxLoader.t('users:form.cancel')}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ChangeUserPassword;
